/** `/c/$companyId/purchases/bills?tab&supplier` — the supplier bills list. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { BILL_LIST_TABS } from "../api/codes";
import { SupplierDocList } from "../bills/list/SupplierDocList";

const search = z.object({
  tab: z.enum(BILL_LIST_TABS).optional().catch(undefined),
  supplier: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/purchases/bills/")({
  validateSearch: (raw) => search.parse(raw),
  component: BillsRoute,
});

function BillsRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  const { tab, supplier } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SupplierDocList
      companyId={companyId}
      kind="bills"
      tab={tab ?? "all"}
      supplier={supplier}
      onSearch={(next) =>
        void navigate({
          search: { tab: BILL_LIST_TABS.find((id) => id === next.tab), supplier: next.supplier },
          replace: true,
        })
      }
    />
  );
}
